var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacilitiesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 18.0001H1.3125C0.58875 18.0001 0 17.4114 0 16.6876V1.44838C0 1.06138 0.1695 0.696876 0.46425 0.446376C0.759 0.195876 1.1475 0.0886259 1.52775 0.153126L9.7695 1.40188C10.4137 1.50913 10.875 2.05363 10.875 2.69788V17.4376C10.875 17.7481 10.623 18.0001 10.3125 18.0001ZM1.31325 1.26088C1.2525 1.26088 1.212 1.28713 1.19175 1.30438C1.167 1.32613 1.125 1.37263 1.125 1.44838V16.6876C1.125 16.7911 1.209 16.8751 1.3125 16.8751H9.75V2.69788C9.75 2.60563 9.684 2.52763 9.59325 2.51263L1.3515 1.26463C1.338 1.26238 1.32525 1.26088 1.31325 1.26088Z",
    fill: "#0E142C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6875 17.9999H10.3125C10.002 17.9999 9.75 17.7479 9.75 17.4374V7.3124C9.75 7.1429 9.8265 6.9824 9.95775 6.8759C10.089 6.76865 10.2615 6.7274 10.4272 6.7619L16.965 8.1314C17.577 8.26715 18 8.79365 18 9.4139V16.6874C18 17.4112 17.4112 17.9999 16.6875 17.9999ZM10.875 16.8749H16.6875C16.791 16.8749 16.875 16.7909 16.875 16.6874V9.4139C16.875 9.3254 16.815 9.2504 16.7287 9.2309L10.875 8.00465V16.8749Z",
    fill: "#0E142C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 17.8125H3.9375C3.627 17.8125 3.375 17.5605 3.375 17.25V14.0625C3.375 13.3387 3.96375 12.75 4.6875 12.75H6.5625C7.28625 12.75 7.87499 13.3387 7.87499 14.0625V17.25C7.87499 17.5605 7.62299 17.8125 7.3125 17.8125ZM4.5 16.6875H6.75V14.0625C6.75 13.959 6.666 13.875 6.5625 13.875H4.6875C4.584 13.875 4.5 13.959 4.5 14.0625V16.6875Z",
    fill: "#0E142C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3125 4.5H3.1875C2.877 4.5 2.625 4.248 2.625 3.9375C2.625 3.627 2.877 3.375 3.1875 3.375H4.3125C4.623 3.375 4.875 3.627 4.875 3.9375C4.875 4.248 4.623 4.5 4.3125 4.5Z",
    fill: "#0E142C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0625 4.5H6.9375C6.627 4.5 6.375 4.248 6.375 3.9375C6.375 3.627 6.627 3.375 6.9375 3.375H8.0625C8.37299 3.375 8.62499 3.627 8.62499 3.9375C8.62499 4.248 8.37299 4.5 8.0625 4.5Z",
    fill: "#0E142C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3125 6.75H3.1875C2.877 6.75 2.625 6.498 2.625 6.1875C2.625 5.877 2.877 5.625 3.1875 5.625H4.3125C4.623 5.625 4.875 5.877 4.875 6.1875C4.875 6.498 4.623 6.75 4.3125 6.75Z",
    fill: "#0E142C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0625 6.75H6.9375C6.627 6.75 6.375 6.498 6.375 6.1875C6.375 5.877 6.627 5.625 6.9375 5.625H8.0625C8.37299 5.625 8.62499 5.877 8.62499 6.1875C8.62499 6.498 8.37299 6.75 8.0625 6.75Z",
    fill: "#0E142C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3125 9H3.1875C2.877 9 2.625 8.748 2.625 8.4375C2.625 8.127 2.877 7.875 3.1875 7.875H4.3125C4.623 7.875 4.875 8.127 4.875 8.4375C4.875 8.748 4.623 9 4.3125 9Z",
    fill: "#0E142C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0625 9H6.9375C6.627 9 6.375 8.748 6.375 8.4375C6.375 8.127 6.627 7.875 6.9375 7.875H8.0625C8.37299 7.875 8.62499 8.127 8.62499 8.4375C8.62499 8.748 8.37299 9 8.0625 9Z",
    fill: "#0E142C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3125 11.25H3.1875C2.877 11.25 2.625 10.998 2.625 10.6875C2.625 10.377 2.877 10.125 3.1875 10.125H4.3125C4.623 10.125 4.875 10.377 4.875 10.6875C4.875 10.998 4.623 11.25 4.3125 11.25Z",
    fill: "#0E142C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0625 11.25H6.9375C6.627 11.25 6.375 10.998 6.375 10.6875C6.375 10.377 6.627 10.125 6.9375 10.125H8.0625C8.37299 10.125 8.62499 10.377 8.62499 10.6875C8.62499 10.998 8.37299 11.25 8.0625 11.25Z",
    fill: "#0E142C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4377 11.25H13.3127C13.0022 11.25 12.7502 10.998 12.7502 10.6875C12.7502 10.377 13.0022 10.125 13.3127 10.125H14.4377C14.7482 10.125 15.0002 10.377 15.0002 10.6875C15.0002 10.998 14.7482 11.25 14.4377 11.25Z",
    fill: "#0E142C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4377 13.5H13.3127C13.0022 13.5 12.7502 13.248 12.7502 12.9375C12.7502 12.627 13.0022 12.375 13.3127 12.375H14.4377C14.7482 12.375 15.0002 12.627 15.0002 12.9375C15.0002 13.248 14.7482 13.5 14.4377 13.5Z",
    fill: "#0E142C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4377 15.75H13.3127C13.0022 15.75 12.7502 15.498 12.7502 15.1875C12.7502 14.877 13.0022 14.625 13.3127 14.625H14.4377C14.7482 14.625 15.0002 14.877 15.0002 15.1875C15.0002 15.498 14.7482 15.75 14.4377 15.75Z",
    fill: "#0E142C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilitiesIcon);
export default __webpack_public_path__ + "static/media/facilities-icon.58a75c62695ae0ebb96f33013c683db9.svg";
export { ForwardRef as ReactComponent };